import { Button, ButtonProps } from '../../Button';

const TableBulkActionButton = ({ children, disabled, icon, ...rest }: Partial<ButtonProps>) => (
    <Button disabled={disabled} icon={icon} variant="primary" iconPosition="left" size="small" {...rest}>
        {children}
    </Button>
);

export default TableBulkActionButton;
